import commonsDev from './commonsDev'
import commonsTest from './commonsTest'
import commonsProdTest from './commonsProdTest'
// import commonsProd from './commonsProd'
import commonsProd from './commonsProd'
// let system = commonsDev
// let system = commonsTest
let system = commonsProd
export default system

